import type { SVGProps } from 'react';

export function SDSDefaultAvatar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <title>Default user avatar</title>
      <g clipPath="url(#clip0_6146_27462)">
        <mask
          id="mask0_6146_27462"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="32"
        >
          <path
            d="M32 16C32 7.16 24.84 0 16 0C7.16 0 0 7.16 0 16C0 24.84 7.16 32 16 32C24.84 32 32 24.84 32 16Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_6146_27462)">
          <path
            d="M32 16C32 7.16 24.84 0 16 0C7.16 0 0 7.16 0 16C0 24.84 7.16 32 16 32C24.84 32 32 24.84 32 16Z"
            fill="currentColor"
          />
          <path
            d="M15.98 18.748C9.006 18.748 3.35 24.4 3.35 31.38C3.35 33.24 4.86 34.748 6.72 34.748H25.25C27.11 34.748 28.61 33.24 28.61 31.38C28.61 24.4 22.96 18.748 15.98 18.748Z"
            fill="white"
          />
          <path
            d="M15.95 19.82C20.21 19.82 23.66 16.37 23.66 12.11C23.66 7.85 20.21 4.4 15.95 4.4C11.69 4.4 8.24 7.85 8.24 12.11C8.24 16.37 11.69 19.82 15.95 19.82Z"
            fill="white"
            stroke="currentColor"
            strokeWidth="3"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6146_27462">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
